import { render } from "./ProjectAdd.vue?vue&type=template&id=1a37d57e&ts=true"
import script from "./ProjectAdd.vue?vue&type=script&lang=ts"
export * from "./ProjectAdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__